import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

export const footerBase = (theme: Theme) => css`
  background-color: ${theme.surface.level1};
  position: relative;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem 0 2rem;
`;

export const footerLink = (bolded: boolean) => css`
  text-decoration: none;
  font-weight: ${bolded ? typography.weightSemiBold : typography.weightBase};
`;
export const footerLogo = css`
  display: block;
  height: 4rem;
`;

export const iconButton = css`
  width: 100%;
  height: 100%;
`;
